import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios
    .get(`${url}/inspection-form-section-fields`, options)
    .then((response) => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta,
      };
    });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/inspection-form-section-fields/${id}?include=inspectionFormSection,copiedField`,
      options
    )
    .then((response) => {
      let inspectionFormSectionField = jsona.deserialize(response.data);
      delete inspectionFormSectionField.links;
      return inspectionForm;
    });
}

function add(inspectionFormSectionField) {
  const payload = jsona.serialize({
    stuff: inspectionFormSectionField,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/inspection-form-section-fields`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(inspectionFormSectionField) {
  const payload = jsona.serialize({
    stuff: inspectionFormSectionField,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(
      `${url}/inspection-form-section-fields/${inspectionFormSectionField.id}`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/inspection-form-section-fields/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
